/**
 * @ComponentFor EPiServer.SpecializedProperties.LinkItemCollection
 */
import * as React from 'react';
import { Link } from '@polarnopyret/scope';

export default (props: Scope.LinkItemCollection) => (
  <ul>
    {props.links.map((link, i) => {
      const { href, text, ...linkProps } = link;
      return (
        <li key={i}>
          <Link {...linkProps} to={href}>
            {text}
          </Link>
        </li>
      );
    })}
  </ul>
);
